import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ConfidentialityAgreement from './pages/ConfidentialityAgreement';
import LicenseCard from './pages/LicenseCard';

const AllRoute = () => {
  return (
    <div>
      <Routes>
        {/* Define the routes */}
        <Route path="/" element={<ConfidentialityAgreement />} />
        <Route path="/liscence" element={<LicenseCard />} />
      </Routes>
    </div>
  );
};

export default AllRoute;
